"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AjaxContentErrors = exports.LoadingState = void 0;
var LoadingState;
exports.LoadingState = LoadingState;

(function (LoadingState) {
  LoadingState["UNLOADED"] = "unloaded";
  LoadingState["LOADING"] = "loading";
  LoadingState["LOADED"] = "loaded";
  LoadingState["FAILED"] = "failed";
})(LoadingState || (exports.LoadingState = LoadingState = {}));

var AjaxContentErrors;
exports.AjaxContentErrors = AjaxContentErrors;

(function (AjaxContentErrors) {
  AjaxContentErrors["FETCH_ERROR"] = "Fetch request failed";
  AjaxContentErrors["REHYDRATE_ERROR"] = "Rehydration failed";
})(AjaxContentErrors || (exports.AjaxContentErrors = AjaxContentErrors = {}));